import { isNil, toNumber } from 'lodash';
import { LayoutPhotoModel } from 'models/photo/layout.model';
import numeral from 'numeral';

function generateRandomNumber() {
  return Math.floor(Math.random() * 10 ** 8);
}

function formatCurrency(s: number | string): string {
  if (isNil(s)) return '';

  return numeral(s).format('$0,0');
}

function formatMoneyVN(num: number): string {
  if (isNil(num)) return '0';

  return numeral(num).format('0,0');
}

function mToSec(num: number | undefined): number {
  return (num || 0) / 1000;
}

function getRandomNumber(min: number, max: number) {
  return Math.floor(Math.random() * (max - min)) + min;
}

function checkSimilarNumber(
  num1: number,
  num2: number,
  digit: number = 4,
): boolean {
  return Math.floor(+num1 * 10 ** digit) === Math.floor(+num2 * 10 ** digit);
}

function addZeroPrefix(num: number | string, isForce: boolean = false) {
  const numConvert = +num || 0;
  if (isForce) {
    return numConvert < 10 ? `0${numConvert}` : numConvert;
  }
  return numConvert < 10 && numConvert > 0 ? `0${numConvert}` : numConvert;
}

function isHigher(
  num1: number | string | undefined | null,
  num2: number | string | undefined | null,
): boolean {
  return toNumber(num1) > toNumber(num2);
}

function calcBgPosition(
  xOfPicture: number | undefined | null,
  sizeOfPicture: number | undefined | null,
  sizeOfLiveview: number | undefined | null,
  padding: number,
): number {
  if (!xOfPicture || !sizeOfLiveview || !sizeOfPicture) return 0;

  return (
    0 -
    (xOfPicture - padding) * (sizeOfLiveview / (sizeOfPicture + padding * 2))
  );
}

function calcBgSize(
  sizeOfLayout: number | undefined | null,
  sizeOfPicture: number | undefined | null,
  padding: number,
): number {
  if (!sizeOfLayout || !sizeOfPicture) return 0;

  return (100 * sizeOfLayout) / (sizeOfPicture + 2 * padding);
}

function calcBgSliceByPosition(
  currentLayout: LayoutPhotoModel | null,
  liveviewSize:
    | {
        width: number;
        height: number;
      }
    | undefined,
  pictureIndex: number,
  padding: number,
): { backgroundSize?: string; backgroundPosition?: string } {
  if (!currentLayout || !liveviewSize) return {};

  return {
    backgroundPosition: `${calcBgPosition(
      currentLayout?.pictures[pictureIndex]?.x,
      currentLayout?.pictures[pictureIndex]?.width,
      liveviewSize?.width,
      padding,
    )}px ${calcBgPosition(
      currentLayout?.pictures[pictureIndex]?.y,
      currentLayout?.pictures[pictureIndex]?.height,
      liveviewSize?.height,
      padding,
    )}px`,
    backgroundSize: `${calcBgSize(
      currentLayout?.width,
      currentLayout?.pictures[pictureIndex]?.width,
      padding,
    )}% ${calcBgSize(
      currentLayout?.height,
      currentLayout?.pictures[pictureIndex]?.height,
      padding,
    )}%`,
  };
}

// tính toán kích thước sau khi xoay
const calculateSizeAfterRotation = (w: number, h: number, deg: number) => {
  const radians = (deg * Math.PI) / 180;

  // Calculate new width and height
  const cos = Math.abs(Math.cos(radians));
  const sin = Math.abs(Math.sin(radians));
  const newWidth = w * cos + h * sin;
  const newHeight = w * sin + h * cos;

  return { width: Math.round(newWidth), height: Math.round(newHeight) };
};

// tính toán vị trí sau khi xoay
const calculateCoordinatesAfterRotation = (
  originalX: number,
  originalY: number,
  originW: number,
  originH: number,
  newWidth: number,
  newHeight: number,
) => {
  // Convert angle from degrees to radians
  const centerPointX = originalX + originW / 2;
  const centerPointY = originalY + originH / 2;

  const newX = centerPointX - newWidth / 2;
  const newY = centerPointY - newHeight / 2;

  return { x: newX, y: newY };
};

export {
  generateRandomNumber,
  formatCurrency,
  formatMoneyVN,
  mToSec,
  getRandomNumber,
  checkSimilarNumber,
  addZeroPrefix,
  isHigher,
  calcBgPosition,
  calcBgSize,
  calcBgSliceByPosition,
  calculateSizeAfterRotation,
  calculateCoordinatesAfterRotation,
};
